import type { FlotiqInStoreDeliveryStore } from "@jti/fe-common";

import { type SelectedShippingAddress } from "../../ShippingForm.types";

export const getInStoreDeliveryMagentoAddress = (
  inStoreDeliveryStore: FlotiqInStoreDeliveryStore
): SelectedShippingAddress => {
  const { StoreName, ZipCode, Street, City, Country, ExternalId } = inStoreDeliveryStore;

  return {
    isPickupAddress: true,
    pickupInformation: {
      store_id: ExternalId,
      store_name: StoreName,
    },
    streetName: Street,
    streetNumber: "",
    streetAdditional: "",
    postcode: ZipCode,
    city: City,
    countryCode: Country,
  };
};
